import request from '@/common/request/request_common'


function packageGetList(data) { return request({ url: '/Sms/PackageGetList', method: 'post', data }) }
function packageBuy(data) { return request({ url: '/Sms/PackageBuy', method: 'post', data }) }
function sendCreate(data) { return request({ url: '/Sms/SendCreate', method: 'post', data }) }
function sendGetList(data) { return request({ url: '/Sms/SendGetList', method: 'post', data }) }
function orderGetOne(data) { return request({ url: '/Sms/OrderGetOne', method: 'post', data }) }
function orderGetList(data) { return request({ url: '/Sms/OrderGetList', method: 'post', data }) }
function merchantGetOne(data) { return request({ url: '/Sms/MerchantGetOne', method: 'post', data }) }

function wxPayQrCode(data) {
  return request({
    url: '/WxPay/Native',
    method: 'post',
    data
  })
}
function wxPayPreId(data) {
  return request({
    url: '/WxPay/CreateOrderByJsapi',
    method: 'post',
    data
  })
}

export default {
  packageGetList,
  packageBuy,
  sendCreate,
  sendGetList,
  orderGetOne,
  orderGetList,
  merchantGetOne,
  wxPayQrCode,
  wxPayPreId
}
